import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { authInterceptor } from './_interceptors/auth.interceptor';
import { httpErrorInterceptor } from './_interceptors/http-error.interceptor';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import { AuthenticationService } from './_services/authentication/authentication.service';
import { initializeApp } from './_helpers/app.initializer';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import moment from 'moment';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localteCat from '@angular/common/locales/ca';

registerLocaleData(localeEs);
registerLocaleData(localteCat);

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, '/assets/i18n/', '.json');

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

const VirtualcenterPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--vc-brand-50)',
      100: 'var(--vc-brand-100)',
      200: 'var(--vc-brand-200)',
      300: 'var(--vc-brand-300)',
      400: 'var(--vc-brand-400)',
      500: 'var(--vc-brand-500)',
      600: 'var(--vc-brand-600)',
      700: 'var(--vc-brand-700)',
      800: 'var(--vc-brand-800)',
      900: 'var(--vc-brand-900)',
      950: 'var(--vc-brand-950)',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    DialogService,
    ConfirmationService,
    provideAppInitializer(() => {
      return initializeApp(inject(AuthenticationService));
    }),

    provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor])),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: VirtualcenterPreset,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
    importProvidersFrom(
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: momentAdapterFactory,
      })
    ),
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
    ),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
};
